import * as React from 'react';

function SvgPropertyBooking(props) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.129.7C1.339.7.7 1.34.7 2.129v9.742c0 .79.64 1.429 1.429 1.429h9.742c.79 0 1.429-.64 1.429-1.429V2.13c0-.79-.64-1.429-1.429-1.429H2.13zm1.81 3.6a.45.45 0 000 .9h6.12a.45.45 0 000-.9H3.94zM3.49 7a.45.45 0 01.45-.45h6.12a.45.45 0 010 .9H3.94A.45.45 0 013.49 7zm.45 1.8a.45.45 0 000 .9h6.12a.45.45 0 000-.9H3.94z"
        fill="#6D7FB4"
      />
    </svg>
  );
}

export default SvgPropertyBooking;
